// Utils
import { useCookies } from 'react-cookie';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';
import useStorage from '../../utils/hooks/useStorage';

function Logout() {
  const [{ user }, dispatch] = useAppContext();
  const { removeItem } = useStorage();
  const navigate = useNavigate();

  const [,, removeCookie] = useCookies(['jwt']);

  useEffect(() => {
    if (user) dispatch({ type: 'SET_USER', payload: null });
    removeCookie('jwt', { path: '/' });
    removeItem('user');
    navigate('/login');
  }, []);

  return null;
}

export default Logout;
